import type { FormSystemName } from "~/types/form_system_name";
import type { ProgramWrapper } from "~/utils/program_wrapper";
import type { Landing } from "~/types/drupal_jsonapi";
import type {
  InputTypeRadioGroupProps,
  InputOption,
  SchemaOptions,
  ValidationFunc,
} from "~/components/Forms/Fields/Base/InputTypesProps";

import { Show, createMemo, createSignal, splitProps } from "solid-js";
import { optional, picklist, safeParse } from "valibot";
import { InputTypeRadioGroup } from "~/components/Forms/Fields/Base/InputTypeRadioGroup";

import ValidationErrors from "./Base/ValidationErrors";
import { shouldShowDestination } from "~/utils/helper_program";

const LABEL = "Quel est votre projet ?";
const HELP = undefined;
const IS_REQUIRED_BY_DEFAULT = true;

const availableOptions: InputOption[] = [
  {
    label: "Acheter pour habiter",
    value: "habiter",
    name: "dwell",
  },
  {
    label: "Acheter pour mettre en location / investir",
    value: "investir",
    name: "invest",
  },
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function DestinationRadioSchema(options?: SchemaOptions) {
  return {
    destination: optional(
      picklist(
        availableOptions.map((o) => o.value),
        "Veuillez sélectionner une destination",
      ),
    ),
  };
}

type DestinationFieldProps = {
  form_name: FormSystemName;
  wrapper?: ProgramWrapper;
  landing?: Landing;
};

export function DestinationRadio(
  props: InputTypeRadioGroupProps & DestinationFieldProps,
) {
  const [local, others] = splitProps(props, [
    "label",
    "help",
    "required",
    "options",
  ]);
  const [validationErrors, setValidationErrors] = createSignal<string[]>([]);

  const validate: ValidationFunc = (input) => {
    const ret = safeParse(DestinationRadioSchema().destination, input);
    ret.success
      ? setValidationErrors([])
      : setValidationErrors(ret.issues.map((issue) => issue.message));
  };

  const showDestination = createMemo(() => {
    if (props.wrapper) {
      return shouldShowDestination(props.wrapper, props.form_name);
    }

    if (props.landing) {
      return shouldShowDestination(props.landing, props.form_name);
    }

    return true;
  });

  return (
    <>
      <Show when={showDestination()}>
        <div class={`form-item-${props.name}`}>
          <InputTypeRadioGroup
            label={local.label || LABEL}
            help={local.help || HELP}
            validateFn={validate}
            required={
              local.required !== undefined
                ? local.required
                : IS_REQUIRED_BY_DEFAULT
            }
            options={local.options || availableOptions}
            {...others}
          />
          <ValidationErrors errors={validationErrors()} field={props.name} />
        </div>
      </Show>
    </>
  );
}
